import { fg } from '@atlassian/jira-feature-gating';

const isQueryByStatusFieldDirectlyEnabled = {
	get(): boolean {
		return fg('jpx-311-remove-fieldconfig-m1');
	},
};

export default isQueryByStatusFieldDirectlyEnabled;
